/* ThyRed — unboxing overlay
 * Opens the #ThyredUnboxingOverlay when the hero's "Watch unboxing" button
 * dispatches the `open-unboxing` event. Ported from the React prototype's
 * UnboxingOverlay component (lost during the Shopify migration).
 */
(function () {
  function init() {
    var overlay = document.getElementById('ThyredUnboxingOverlay');
    if (!overlay) return;

    var video = overlay.querySelector('[data-unbox-video]');

    function open() {
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      if (video && typeof video.play === 'function') {
        try { video.currentTime = 0; video.play(); } catch (e) {}
      }
    }

    function close() {
      overlay.hidden = true;
      document.body.style.overflow = '';
      if (video && typeof video.pause === 'function') {
        try { video.pause(); } catch (e) {}
      }
    }

    // Open from the hero button (and anything else that fires the event)
    window.addEventListener('open-unboxing', open);

    // Close: Escape key
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    // Close: the X button
    var closeBtn = overlay.querySelector('[data-unbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Close: click on the dim backdrop, but not on the video frame itself
    overlay.addEventListener('click', function (e) {
      var frame = overlay.querySelector('.unbox-frame');
      if (frame && !frame.contains(e.target)) close();
    });

    // Tap the video itself to toggle play/pause
    if (video) {
      video.addEventListener('click', function () {
        if (video.paused) { video.play(); } else { video.pause(); }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
